import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth/AuthContext';
import GlobalErrorBoundary from './components/GlobalErrorBoundary';
import { installGlobalErrorTelemetry } from './utils/globalErrorTelemetry';
import { installLegacyMediaQueryCompatibility } from './utils/legacyBrowserCompatibility';

installLegacyMediaQueryCompatibility();
installGlobalErrorTelemetry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </GlobalErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
